module.exports = __webpack_public_path__ + "img/Academic_Writing.4d19c0a3.jpg";